// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__kvfEY","nav_right":"Header_nav_right__WTyXc","logo":"Header_logo__UsziS","navcontent":"Header_navcontent__7dD2N","brand":"Header_brand__5ovdD"};